<template>
  <header :class="[currentPage !== '/' ? regClass : homeClass]">
    <router-link :to="{ name: 'home' }" v-if="currentPage !== '/'">HOME</router-link>
    <a href="https://jovanaivic.pic-time.com/portfolio">PORTFOLIO</a>
    <router-link :to="{ name: 'investment' }"
                 v-bind:class="{'router-link-exact-active': currentPage === '/pricing'}">PRICING
    </router-link>
    <router-link :to="{ name: 'contact' }">CONTACT</router-link>
  </header>
</template>

<script>
export default {
  data() {
    return {
      homeClass: 'home-page',
      regClass: 'reg-page'
    }
  },
  computed: {
    currentPage() {
      return this.$route.path;
    }
  }
}
</script>